import moment from 'moment';

export default {
  methods: {
    getLocalTimeFromUTC(utcTime) {
      return moment.utc(utcTime).local().format('YYYY-MM-DD HH:mm:ss');
    }    
  }
}